import { ChangeEvent, useState } from 'react';
import Dropdown from '../reusable/Dropdown';
import '../../styles/reusable/CollapsibleSection.css';

interface ScriptOption {
  value: string;
  label: string;
  description: string;
  impact: string;
}

interface DataFixScriptSectionProps {
  selectedScript: string;
  onScriptChange: (e: ChangeEvent<HTMLSelectElement>) => void;
  scriptOptions: ScriptOption[];
  description?: string;
  impact?: string;
  title?: string;
  defaultExpanded?: boolean;
}

/**
 * Reusable Data Fix Script Section
 * Used across all script execution pages
 * Only dropdown options differ per page
 */
const DataFixScriptSection = ({
  selectedScript,
  onScriptChange,
  scriptOptions,
  description,
  impact,
  title = 'Run Data Fix Script',
  defaultExpanded = true,
}: DataFixScriptSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(defaultExpanded);

  const dropdownOptions = scriptOptions.map(script => ({
    value: script.value,
    label: script.label,
  }));

  return (
    <div className="collapsible-section">
      <div className="section-header" onClick={() => setIsExpanded(!isExpanded)}>
        <h3>{title}</h3>
        <span className="collapse-icon">{isExpanded ? '−' : '+'}</span>
      </div>
      {isExpanded && (
        <div className="section-content">
          <div className="form-grid">
        <Dropdown
          label="Select Script"
          name="selectedScript"
          value={selectedScript}
          onChange={onScriptChange}
          options={dropdownOptions}
          placeholder="Select a script to run"
          required
        />

        {description && (
          <div className="script-info-group">
            <label className="script-info-label">Script Description</label>
            <div className="script-info-box">{description}</div>
          </div>
        )}

        {impact && (
          <div className="script-info-group">
            <label className="script-info-label">Impact Scope</label>
            <div className="script-info-box impact-box">{impact}</div>
          </div>
        )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DataFixScriptSection;
